import { useReducer } from 'react';

function useToggle(initialValue = false) {
  const [isOpen, setOpen] = useReducer((prev) => !prev, initialValue);

  return [isOpen, setOpen];
}

export default useToggle;
